export const getUgMotorInsuranceState = (state) => state?.ugMotorInsurance;
